import { create } from "zustand";
import { persist } from "zustand/middleware";

export type FontScaleLevel = "small" | "normal" | "large" | "xlarge";

/** 레벨 → html 루트 font-size(px). 브라우저 기본값은 16px(=normal). */
export const FONT_SCALE_PX: Record<FontScaleLevel, number> = {
  small: 14,
  normal: 16,
  large: 18,
  xlarge: 20,
};

export const FONT_SCALE_LABEL: Record<FontScaleLevel, string> = {
  small: "작게",
  normal: "기본",
  large: "크게",
  xlarge: "아주 크게",
};

/** UI 노출 순서 */
export const FONT_SCALE_LEVELS: FontScaleLevel[] = [
  "small",
  "normal",
  "large",
  "xlarge",
];

const DEFAULT_LEVEL: FontScaleLevel = "normal";

interface FontScaleStore {
  fontScale: FontScaleLevel;
  setFontScale: (level: FontScaleLevel) => void;
  resetFontScale: () => void;
}

export const useFontScaleStore = create<FontScaleStore>()(
  persist(
    (set) => ({
      fontScale: DEFAULT_LEVEL,
      setFontScale: (fontScale) => set({ fontScale }),
      resetFontScale: () => set({ fontScale: DEFAULT_LEVEL }),
    }),
    {
      name: "font-scale-store",
      version: 1,
      partialize: (state) => ({ fontScale: state.fontScale }),
      migrate: (persisted) => {
        // 알 수 없는 값 방어 — 유효하지 않으면 기본값으로 복원
        const state = persisted as Partial<Pick<FontScaleStore, "fontScale">> | undefined;
        if (!state || !state.fontScale || !(state.fontScale in FONT_SCALE_PX)) {
          return { fontScale: DEFAULT_LEVEL };
        }
        return { fontScale: state.fontScale };
      },
    },
  ),
);
